import { ParseKeys } from 'i18next'
import { useEffect, useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { isString } from 'xstate/es/utils'
import { FormValues } from '~/entities/common/WorkRule/ui/Form'
import {
  fuelTypeEnumLabels,
  transmissionEnumLabels,
} from '~/shared/config/constants'

export const useGeneratedTitle = (
  form: UseFormReturn<FormValues>,
  onTitleChange?: (title: string) => void,
) => {
  const { t } = useTranslation()

  const [
    vehicleCategoryId,
    transmissionType,
    regionsIds,
    manufactureYears,
    pricePerDay,
    fuelTypes,
    carModelOption,
    isPromotion,
  ] = form.watch([
    'vehicleCategoryId',
    'transmissionType',
    'regionsIds',
    'manufactureYears',
    'pricePerDay',
    'fuelTypes',
    'carModelOption',
    'isPromotion',
  ])

  const title = useMemo(
    () =>
      // Категория ТС, ТИП КПП, Регион, Год Выпуска, Стоимость в сутки, Модель авто, Вид топлива
      [
        isString(vehicleCategoryId)
          ? vehicleCategoryId
          : vehicleCategoryId?.label,
        t(
          (isString(transmissionType)
            ? transmissionEnumLabels[transmissionType]
            : transmissionType?.label) as ParseKeys,
        ),
        regionsIds
          ?.map((region) => (isString(region) ? region : region?.label))
          .join(', '),
        manufactureYears,
        pricePerDay,
        isString(carModelOption) ? carModelOption : carModelOption?.label,
        fuelTypes
          ?.map((fuelType) =>
            t(
              (isString(fuelType)
                ? fuelTypeEnumLabels[fuelType]
                : fuelType?.label) as ParseKeys,
            ),
          )
          .join(', '),
        isPromotion ? t('form.promotion') : '',
      ]
        .filter(Boolean)
        .join(', '),
    [
      t,
      vehicleCategoryId,
      transmissionType,
      regionsIds,
      manufactureYears,
      pricePerDay,
      carModelOption,
      fuelTypes,
      isPromotion,
    ],
  )

  useEffect(() => {
    form.setValue('title', title)
    onTitleChange?.(title)
    // eslint-disable-next-line
  }, [title])
}
